<div class="pricing-container">

  <div class="pricing-header">
    <h2 class="pricing-title">Tariff</h2>
  </div>

  <!-- Tier and Version selectors -->
  <div class="selector-row">

    <mat-form-field appearance="outline" class="tier-field">
      <mat-label>Tier</mat-label>
      <mat-select [(ngModel)]="selectedTierName" (ngModelChange)="onTierNameChange()">
        <mat-option *ngFor="let name of tierNames" [value]="name">{{ name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="version-field" *ngIf="versionsForTier.length">
      <mat-label>Version</mat-label>
      <mat-select [(ngModel)]="selectedVersionId" (ngModelChange)="onVersionChange()">
        <mat-option *ngFor="let v of versionsForTier" [value]="v.id">
          {{ getVersionLabel(v) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button class="renew-btn"
            *ngIf="selectedVersion && isActiveVersion(selectedVersion) && !isRenewing && currentItems.length"
            (click)="startRenew()">
      <mat-icon>add_circle_outline</mat-icon> Renew
    </button>

  </div>

  <!-- Current version items table -->
  <div *ngIf="selectedVersion && !loadingItems" class="items-section">

    <h3 class="section-heading">
      Current Prices &mdash; {{ selectedVersion.name }}
      <span class="version-date-badge">{{ getVersionLabel(selectedVersion) }}</span>
    </h3>

    <table class="pricing-table" *ngIf="currentItems.length; else noItems">
      <thead>
        <tr>
          <th>Item</th>
          <th class="cost-col">Cost</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of currentItems">
          <td>{{ getItemLabel(item) }}</td>
          <td class="cost-col">{{ item.cost | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>

    <ng-template #noItems>
      <p class="no-data">No pricing items found for this version.</p>
    </ng-template>

  </div>

  <div *ngIf="loadingItems" class="loading-msg">Loading items&hellip;</div>

  <!-- Renew form -->
  <div *ngIf="isRenewing" class="renew-section">

    <h3 class="section-heading">New Version — {{ selectedVersion?.name }}</h3>

    <div class="renew-date-row">
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>New Start Date</mat-label>
        <input matInput [matDatepicker]="renewPicker" [(ngModel)]="renewStartDate">
        <mat-datepicker-toggle matIconSuffix [for]="renewPicker"></mat-datepicker-toggle>
        <mat-datepicker #renewPicker></mat-datepicker>
      </mat-form-field>
      <span class="renew-date-note">
        The current version will be end-dated the day before this date.
      </span>
    </div>

    <table class="pricing-table renew-table">
      <thead>
        <tr>
          <th>Item</th>
          <th class="cost-col">New Cost</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of renewItems">
          <td>{{ getItemLabel(item) }}</td>
          <td class="cost-col">
            <input class="cost-input" type="number" min="0" step="0.01" [(ngModel)]="item.cost" placeholder="0.00">
          </td>
        </tr>
      </tbody>
    </table>

    <div class="renew-actions">
      <button mat-raised-button class="save-btn"
              [disabled]="!allCostsFilled() || saving"
              (click)="saveRenew()">
        <mat-icon>save</mat-icon> {{ saving ? 'Saving…' : 'Save New Version' }}
      </button>
      <button mat-button class="cancel-btn" (click)="cancelRenew()" [disabled]="saving">
        Cancel
      </button>
    </div>

  </div>

</div>
